import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { BRAND } from "../lib/constants";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();
  const isHome = loc.pathname === "/";

  const links = [
    { label: "How it works", href: "#how" },
    { label: "Why GigDrive", href: "#why" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <header
      className="sticky top-0 z-50 bg-white border-b-2 border-black"
      data-testid="main-navbar"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 md:h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img src={BRAND.logo} alt="GigDrive Rentals" className="h-11 md:h-14 w-auto" />
          <div className="leading-none">
            <div className="font-display font-black text-xl md:text-3xl tracking-tighter">
              GigDrive <span className="text-[#E60012]">Rentals.</span>
            </div>
            <div className="font-mono text-[9px] md:text-[10px] uppercase tracking-[0.25em] text-black/50 mt-1 hidden sm:block">
              Built for gig drivers
            </div>
          </div>
        </Link>

        {isHome && (
          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="font-mono text-xs font-bold uppercase tracking-[0.2em] hover:text-[#E60012] gd-snappy"
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
          </nav>
        )}

        <div className="flex items-center gap-2">
          <Link
            to="/admin/login"
            className="hidden md:inline-flex font-mono text-xs font-bold uppercase tracking-[0.2em] text-black/50 hover:text-black gd-snappy"
            data-testid="nav-admin"
          >
            Admin
          </Link>
          <button
            onClick={() => navigate("/apply")}
            className="font-display font-bold uppercase text-sm tracking-wider bg-black text-white px-5 py-3 hover:bg-[#E60012] gd-snappy"
            data-testid="nav-apply-btn"
          >
            Apply Now →
          </button>
          <button
            className="md:hidden ml-1 p-2 border border-black"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-black bg-white">
          <div className="px-5 py-4 flex flex-col gap-4">
            {isHome &&
              links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-mono text-xs font-bold uppercase tracking-[0.2em]"
                >
                  {l.label}
                </a>
              ))}
            <Link
              to="/admin/login"
              onClick={() => setOpen(false)}
              className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-black/60"
            >
              Admin
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
